import useTranslation from "next-translate/useTranslation";

type Props = {
  onEditBtnClick: () => void;
  selectedDate: Date;
};

const Header = ({ onEditBtnClick, selectedDate }: Props) => {
  const { t } = useTranslation("common");

  return (
    <div>
      <div className="d-block d-md-none">
        <h3 className="d-flex  align-items-center flex-column mt-3 mb-0">
          <span className="text-center w-100 fs-lg">
            {t(`donations_record`)}
          </span>
        </h3>
      </div>
      <div
      // className="d-none d-md-block"
      >
        <h3 className="d-flex  align-items-center  mb-3 flex-column mt-3">
          <span className="mx-2 fs-xl  text-primary text-center d-flex align-items-center justify-content-center w-100 ">
            <span
              className=" rounded-1 px-3 d-flex align-items-center cursor  bg-secondary"
              style={{ width: "fit-content", height:46 }}
              onClick={onEditBtnClick}
            >
              <i className="fe-calendar me-2 fw-semibold"></i>
              {selectedDate?.toISOString().split("T")[0]}
            </span>
          </span>
        </h3>
      </div>
    </div>
  );
};

export default Header;
